// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import VueTinySlider from "vue-tiny-slider";
import ModuleBase from "#/common/ModuleBase";
import moment from "moment";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    VueTinySlider,
  },
})
export class AppointmentModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get visibleAppointments() {
    if (this.$store.page.isInEditMode) {
      return this.instance["appointments"];
    } else {
      return this.instance["appointments"].filter((a) => {
        let startDate = a["start_date"];
        let endDate = a["end_date"];
        let now = moment();

        if (endDate) {
          return moment(a["end_date"], "DD.MM.YYYY").isSameOrAfter(now, "day");
        } else {
          return moment(a["start_date"], "DD.MM.YYYY").isSameOrAfter(
            now,
            "day"
          );
        }
      });
    }
  }

  public getDay(appointment) {
    let splitDate = appointment.split(".");

    if (splitDate[0] !== undefined) return splitDate[0];

    return null;
  }

  public getMonth(appointment) {
    let splitDate = appointment.split(".");

    if (splitDate[1] !== undefined) {
      let langKey: string = "MONTH_";

      switch (splitDate[1]) {
        case "01":
          langKey += "JANUARY";
          break;

        case "02":
          langKey += "FEBRUARY";
          break;

        case "03":
          langKey += "MARCH";
          break;

        case "04":
          langKey += "APRIL";
          break;

        case "05":
          langKey += "MAY";
          break;

        case "06":
          langKey += "JUNE";
          break;

        case "07":
          langKey += "JULY";
          break;

        case "08":
          langKey += "AUGUST";
          break;

        case "09":
          langKey += "SEPTEMBER";
          break;

        case "10":
          langKey += "OCTOBER";
          break;

        case "11":
          langKey += "NOVEMBER";
          break;

        case "12":
          langKey += "DECEMBER";
          break;
      }

      return langKey;
    }

    return null;
  }

  public getTime(startTime, endTime) {
    let time: string = "";

    if (startTime !== "") {
      let startTimeArr = startTime.split(":");

      time += startTimeArr[0] + "." + startTimeArr[1];
    }

    if (endTime !== "") {
      if (startTime !== "") time += " - ";

      let endTimeArr = endTime.split(":");

      time += endTimeArr[0] + "." + endTimeArr[1];
    }

    return time;
  }
}
